namespace TabAurous.Production {
    export interface SplittingItemsForm {
        TransId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        CustomerId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Parts: Serenity.IntegerEditor;
        Weight: WeightEditor;
        NetWeight: WeightEditor;
        DiamondWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        DeliveryDate: Serenity.DateEditor;
        TreeId: Serenity.StringEditor;
        TreeItemId: Serenity.StringEditor;
        TreeNo: Serenity.StringEditor;
    }

    export class SplittingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.SplittingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SplittingItemsForm.init)  {
                SplittingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = WeightEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(SplittingItemsForm, [
                    'TransId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'CustomerId', w1,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'Pieces', w1,
                    'Parts', w1,
                    'Weight', w2,
                    'NetWeight', w2,
                    'DiamondWeight', w2,
                    'DiamondPieces', w1,
                    'StoneWeight', w2,
                    'StonePieces', w1,
                    'OtherWeight', w2,
                    'OtherPieces', w1,
                    'Purity', w3,
                    'PureWeight', w2,
                    'DeliveryDate', w4,
                    'TreeId', w0,
                    'TreeItemId', w0,
                    'TreeNo', w0
                ]);
            }
        }
    }
}
